import React from "react";
import Content from "./Content";
import ContentType2 from "./ContentType2";
import ContentType3 from "./ContentType3";
import Quiz from "./Quiz";
import EmergenceContent from "./EmergenceContent";
import speakerImg from "../../../assets/images/others/ButtonSpeaker.png";
import s from "./style.module.css";

const ContentBox = ({
  ContentArray,
  Repeat,
  contentID,
  handleGetAnswer,
  handleRepeat,
}) => {
  return (
    <div className={s.ContentBox}>
      <div className={s.ContentWrapper}>
        {ContentArray.filter((item) => item.id === contentID).map(
          (item, index) => (
            <React.Fragment key={index}>
              {!item.question_label ? (
                <div className={s.ContentItems} key={index}>
                  {!!item.emegenceImg ? (
                    <EmergenceContent item={item} />
                  ) : !!item.hyperText ? (
                    <ContentType2 contentID={contentID} item={item} />
                  ) : !!item.videoLink ? (
                    <ContentType3 item={item} />
                  ) : (
                    <Content contentID={contentID} item={item} />
                  )}
                </div>
              ) : (
                <div key={index}>
                  <Quiz
                    index={index}
                    Repeat={Repeat}
                    item={item}
                    handleGetAnswer={handleGetAnswer}
                    speakerImg={speakerImg}
                    handleRepeat={handleRepeat}
                  />
                </div>
              )}
            </React.Fragment>
          )
        )}
      </div>
    </div>
  );
};

export default ContentBox;
